import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  width: 100%;
  background-color: ${colors.background};
`

export const Ul = styled.ul`
  list-style: none;
  padding: 0;
`

export const Li = styled.li`
  margin-bottom: 8px;
`
